export default {
  title: 'Infra',
  sidebar: {
    title1: 'Create Channel',
    title2: 'Channel Details',
    title3: 'Update Channel'
  },
  topbar: {
    button1: 'Create Channel'
  },
  name: {
    label: 'Name',
    placeholder: 'Enter Channel Name',
    validation: {
      required: 'Name is required'
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Enter Channel Description',
    validation: {
      required: 'Description is required'
    }
  },
  clientId: {
    label: 'Client Id'
  },
  type: {
    label: 'Choose Type',
    placeholder: 'Choose Type',
    validation: {
      required: 'Type is required'
    }
  },
  domains: {
    label: 'Domains',
    placeholder: 'Type and press enter',
    validation: {
      required: 'Domains is required',
      min: 'At least 1 domain has to be added'
    }
  },
  create: {
    label: 'Create Channel',
    success: 'Successfully Created the Channel'
  },
  update: {
    label: 'Update Channel',
    success: 'Successfully Updated the Channel'
  },
  generate: {
    label: 'Generate Client Id',
    confirm: {
      title: 'Confirm',
      body: 'You are going to Generate API Key. This will clear existing Id. This action is not reversible. Do you want to continue?',
      button: 'Generate'
    },
    success: 'Successfully generated client id.'
  }
};
